import { env } from '../lib/env'

/**
 * CRA: `npm start` sets NODE_ENV=development (same role as `import.meta.env.DEV` in Vite / adamo-id).
 */
export function isDevEnvironment(): boolean {
  return process.env.NODE_ENV === 'development'
}

/**
 * Same as adamo-id: `import.meta.env.DEV && !env.VITE_ACTIVATE_SSO_FLOW_IN_DEV`
 */
export function isLocalDevWithoutSso(): boolean {
  return isDevEnvironment() && !env.REACT_APP_ACTIVATE_SSO_FLOW_IN_DEV
}

/**
 * Same as adamo-id: `!import.meta.env.DEV || env.VITE_ACTIVATE_SSO_FLOW_IN_DEV`
 */
export function isSuiteSsoRedirectMode(): boolean {
  return !isDevEnvironment() || env.REACT_APP_ACTIVATE_SSO_FLOW_IN_DEV
}
